import axios from 'axios'

/**
 * Encendido/apagado de platos de la carta OD, via el backend de catering.
 *
 * Antes el switch pegaba directo del navegador al backoffice y NADIE
 * registraba quien apago que plato. Ahora pasa por nuestro backend, que
 * reenvia el cambio al mismo endpoint del backoffice (mismo efecto) y deja
 * el log con el usuario de la sesion.
 *
 * El token del backoffice viaja en el header X-Backoffice-Token porque el
 * Authorization normal lleva el token de catering (lo exige el auth:api).
 */
export default {
  /**
   * @param {string} mealId  restaurant_foodcourt_meal.id (UUID, es lo que trae `row.id` en la
   *                         tabla de la carta — el `numeric_id` NO es el id del switch, aunque
   *                         se llame asi; el backend resuelve numeric_id aparte para el log)
   * @param {{status: boolean, oldStatus?: boolean, mealName?: string, restaurantId?: number}} datos
   */
  cambiarStatus (mealId, datos) {
    return axios.put(
      `/foodcourt/meals/${mealId}/status`,
      {
        status: datos.status,
        old_status: datos.oldStatus,
        meal_name: datos.mealName,
        restaurant_id: datos.restaurantId
      },
      { headers: { 'X-Backoffice-Token': window.localStorage.token_backoffice || '' } }
    ).then(r => (r.data && r.data.payload) || {})
  },

  platos () {
    return axios.get('/foodcourt/carta', {
      headers: { 'X-Backoffice-Token': window.localStorage.token_backoffice || '' }
    }).then(r => (r.data && r.data.payload && r.data.payload.result) || {})
  },

  /** Historial de cambios de la cocina del token. */
  historial (desde, hasta) {
    const params = {}
    if (desde) params.from = desde
    if (hasta) params.to = hasta

    return axios.get('/foodcourt/meals/status-logs', { params })
      .then(r => (r.data && r.data.payload) || {})
  }
}
